import { render, staticRenderFns } from "./RegisterHeader.vue?vue&type=template&id=4dc3fa2a&scoped=true&"
import script from "./RegisterHeader.vue?vue&type=script&lang=ts&"
export * from "./RegisterHeader.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterHeader.vue?vue&type=style&index=0&id=4dc3fa2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc3fa2a",
  null
  
)

export default component.exports